import { EXPERIMENT_NAMES } from '@/modules/experiment/domain/experiment.constants';
import { QUIZ_VARIANTS } from '@/modules/tour/domain/tour';

export default {
  name: EXPERIMENT_NAMES.SOMATIC_YOGA_LP_ADD_SUBHEADER,
  includedRoutes: ['/tour/somatic-yoga', '/tour/somatic-yoga/'],
  variants: [
    {
      tour: QUIZ_VARIANTS.SOMATIC_YOGA,
      path: `/tour/${QUIZ_VARIANTS.SOMATIC_YOGA}`,
    },
    {
      tour: QUIZ_VARIANTS.SOMATIC_YOGA_LP_ADD_SUBHEADER,
      path: `/tour/${QUIZ_VARIANTS.SOMATIC_YOGA_LP_ADD_SUBHEADER}`,
    },
  ],
};
